import { render, staticRenderFns } from "./dropdown_section_header.vue?vue&type=template&id=346c0a41"
import script from "./dropdown_section_header.vue?vue&type=script&lang=js"
export * from "./dropdown_section_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports